<template lang="pug">
  .flex-1
    .row.mx-5.mt-5
      button(@click="goBack" type="button" class="btn btn-light")
        <i class="fas fa-angle-double-left mr-1"></i>
        | Вернуться назад
    .row.mx-5.mt-2
      h4 Ваши реквизиты
    .row.mx-5.mt-2
      textarea(v-model="rek" class="form-control" style="width: 100%; resize: none;" rows="14" placeholder="Пример реквизитов:\n\nИП. Коробков Е.А.\n\nИНН: 2116 048 049 46\nОГРНИП: 3162 1300 0095 526\n\nБанк: АО «Тинькофф Банк»\nР/с: 40802810400000213827\nКор/с: 30101810145250000974\nБИК: 044525974")
    .row.mx-5.mt-2
      a(:href="bill_url" target="_blank" type="button" class="btn btn-primary") Сгенерировать счет на оплату
</template>

<script>
import urls from '@/lib/urls'
import Bitrix24 from '@/lib/Bitrix24'

export default {
  data() {
    return {
      rek: '',
      bill_number: (Date.now()).toString(),
      bill_url: '',
      domain: ''
    }
  },
  async created() {
    let auth_info = await Bitrix24.getAuthInfo()
    if(auth_info){
      this.domain = auth_info.domain
      this.bill_url = urls.SITE_URL+'/bill?data='+JSON.stringify(this.rek)+'&summ='+this.$route.query.summ+'&bill_number='+this.bill_number+'&domain='+this.domain
    }
  },
  methods: {
    goBack(){
      this.$router.push('/')
    }
  },
  watch: {
    rek(){
      this.bill_url = urls.SITE_URL+'/bill?data='+JSON.stringify(this.rek)+'&summ='+this.$route.query.summ+'&bill_number='+this.bill_number+'&domain='+this.domain
    }
  },
}
</script>

<style>

</style>